import React from 'react';
import Icon from '../../../components/AppIcon';

const MaterialsHero = () => {
  const materialCategories = [
    { name: 'Tecidos Premium', icon: 'Sparkles' },
    { name: 'Cordas Naturais', icon: 'TreePine' },
    { name: 'Fibras Especiais', icon: 'Leaf' },
    { name: 'Madeiras Nobres', icon: 'Package' }
  ];

  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-muted py-20 lg:py-32 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-32 border border-primary/20 rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-primary/20 rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-40 h-40 border border-primary/20 rounded-full"></div>
        <div className="absolute bottom-10 right-10 w-20 h-20 border border-primary/20 rounded-full"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-primary/10 rounded-full px-4 py-2 mb-6">
            <Icon name="Package" size={16} color="var(--color-primary)" />
            <span className="text-primary font-medium text-sm">Materiais Premium</span>
          </div>

          {/* Title */}
          <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6">
            Catálogo de Materiais
          </h1>
          
          {/* Description */}
          <p className="text-text-secondary text-lg md:text-xl mb-10 leading-relaxed max-w-2xl mx-auto">
            Explore nossa coleção completa de materiais premium para personalizar seus móveis artesanais com qualidade e elegância.
          </p>

          {/* Categories */}
          <div className="flex flex-wrap justify-center gap-3">
            {materialCategories.map((category, index) => (
              <div
                key={index}
                className="group inline-flex items-center space-x-2 bg-card border border-border rounded-full px-4 py-2 hover:border-primary hover:shadow-premium transition-all duration-300"
              >
                <Icon name={category.icon} size={16} color="var(--color-primary)" />
                <span className="text-foreground font-medium text-sm group-hover:text-primary transition-colors duration-300">
                  {category.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MaterialsHero;

